export const STEP_RANGE = [
  {
    id: 1,
    label: 'エントリー',
    value: 'registration',
  },
  {
    id: 2,
    label: '書類選考',
    value: 'document_screening',
  },
  {
    id: 4,
    label: '1次面接',
    value: '1st_interview',
  },
  {
    id: 5,
    label: '2次面接',
    value: '2nd_interview',
  },
  {
    id: 6,
    label: '3次面接',
    value: '3rd_interview',
  },
  {
    id: 7,
    label: '4次面接以降',
    value: '4th_interview',
  },
  {
    id: 8,
    label: '最終面接',
    value: 'final_meeting',
  },
  {
    id: 9,
    label: '内定',
    value: 'offered',
  },
  {
    id: 10,
    label: '決定',
    value: 'closed',
  },
] as const;

export const ORDER_ITEMS = [
  { value: '-updated_at', label: '更新が新しい順' },
  { value: 'updated_at', label: '更新が古い順' },
  { value: '-last_acted_at', label: '選考日時が近い順' },
  { value: '-candidate_id', label: '求職者順' },
  { value: '-provided_job_posts.company_id', label: '企業順' },
];

export const DISPLAY_ITEMS = [
  {
    label: '日程調整中',
    value: 'adjust_scheduling',
  },
  {
    label: '日程調整済み',
    value: 'scheduled',
  },
  {
    label: '結果待ち',
    value: 'result_waiting',
  },
];

export const RESULT_ITEMS = [
  {
    label: 'すべて',
    value: 'all',
  },
  {
    label: '進行中',
    value: 'in_progress',
  },
  {
    label: '不採用',
    value: 'rejected',
  },
  {
    label: '辞退',
    value: 'declined',
  },
  {
    label: '決定',
    value: 'closed',
  },
];

export const NEXT_STEPS = [
  {
    label: '次面接',
    value: 'interview',
  },
  {
    label: '最終面接',
    value: 'final_interview',
  },
  {
    label: '面談',
    value: 'meeting',
  },
  {
    label: 'オファー面談',
    value: 'offer_meeting',
  },
  {
    label: 'リファレンスチェック',
    value: 'reference_check',
  },
  {
    label: '適性検査',
    value: 'spi',
  },
];

export const STEP_RESULT_PATTERNS = [
  {
    label: '通過',
    value: 'passing',
  },
  {
    label: '不採用',
    value: 'rejected',
  },
  {
    label: '辞退',
    value: 'declined',
  },
];
